export default {
  pt: {
    'tickets.ticketDetailPage.ticket': 'Ticket',
    'tickets.ticketDetailPage.ticketNumber': 'Ticket {{number}}',
    'tickets.ticketDetailPage.eyebrow': 'Operação',
    'tickets.ticketDetailPage.situation': 'Situação',
    'tickets.ticketDetailPage.priorityValue': 'Prioridade: {{priority}}',
    'tickets.ticketDetailPage.customer': 'Cliente',
    'tickets.ticketDetailPage.contract': 'Contrato',
    'tickets.ticketDetailPage.loadsQty': 'Qtd. cargas',
    'tickets.ticketDetailPage.desiredDate': 'Data desejada',
    'tickets.ticketDetailPage.generatedLoads': 'Cargas geradas',
    'tickets.ticketDetailPage.product': 'Produto',
    'tickets.ticketDetailPage.origin': 'Origem',
    'tickets.ticketDetailPage.destination': 'Destino',
    'tickets.ticketDetailPage.priority': 'Prioridade',
    'tickets.ticketDetailPage.start': 'Início',
    'tickets.ticketDetailPage.intervalMin': 'Intervalo (min)',
    'tickets.ticketDetailPage.transitMin': 'Trajeto (min)',
    'tickets.ticketDetailPage.volumePerLoad': 'Volume/carga',
    'tickets.ticketDetailPage.notes': 'Observações',
    'tickets.ticketDetailPage.generatedLoadsCount': 'Cargas geradas ({{count}})',
    'tickets.ticketDetailPage.schedule': 'Saída campo {{departure}} · chega {{arrival}}',
    'tickets.ticketDetailPage.noLoads': 'Nenhuma carga gerada ainda. Aprovar o ticket gera as cargas com a cadência calculada.',
    'tickets.ticketDetailPage.priority.low': 'Baixa',
    'tickets.ticketDetailPage.priority.normal': 'Normal',
    'tickets.ticketDetailPage.priority.high': 'Alta',
    'tickets.ticketDetailPage.priority.urgent': 'Urgente',
    'tickets.ticketDetailPage.status.ticket.draft': 'Rascunho',
    'tickets.ticketDetailPage.status.ticket.submitted': 'Enviada',
    'tickets.ticketDetailPage.status.ticket.under_review': 'Em análise',
    'tickets.ticketDetailPage.status.ticket.approved': 'Aprovada',
    'tickets.ticketDetailPage.status.ticket.in_progress': 'Em execução',
    'tickets.ticketDetailPage.status.ticket.completed': 'Concluída',
    'tickets.ticketDetailPage.status.ticket.cancelled': 'Cancelada',
    'tickets.ticketDetailPage.status.shipment.draft': 'Rascunho',
    'tickets.ticketDetailPage.status.shipment.awaiting_harvest': 'Aguardando colheita',
    'tickets.ticketDetailPage.status.shipment.loading': 'Carregando',
    'tickets.ticketDetailPage.status.shipment.awaiting_invoice': 'Aguardando nota fiscal',
    'tickets.ticketDetailPage.status.shipment.awaiting_unload': 'Aguardando descarga',
    'tickets.ticketDetailPage.status.shipment.unloading': 'Em descarga',
    'tickets.ticketDetailPage.status.shipment.released': 'Liberada',
    'tickets.ticketDetailPage.status.shipment.cancelled': 'Cancelada',
  },
  en: {
    'tickets.ticketDetailPage.ticket': 'Ticket',
    'tickets.ticketDetailPage.ticketNumber': 'Ticket {{number}}',
    'tickets.ticketDetailPage.eyebrow': 'Operations',
    'tickets.ticketDetailPage.situation': 'Situation',
    'tickets.ticketDetailPage.priorityValue': 'Priority: {{priority}}',
    'tickets.ticketDetailPage.customer': 'Customer',
    'tickets.ticketDetailPage.contract': 'Contract',
    'tickets.ticketDetailPage.loadsQty': 'Qty. loads',
    'tickets.ticketDetailPage.desiredDate': 'Desired date',
    'tickets.ticketDetailPage.generatedLoads': 'Generated loads',
    'tickets.ticketDetailPage.product': 'Product',
    'tickets.ticketDetailPage.origin': 'Origin',
    'tickets.ticketDetailPage.destination': 'Destination',
    'tickets.ticketDetailPage.priority': 'Priority',
    'tickets.ticketDetailPage.start': 'Start',
    'tickets.ticketDetailPage.intervalMin': 'Interval (min)',
    'tickets.ticketDetailPage.transitMin': 'Transit (min)',
    'tickets.ticketDetailPage.volumePerLoad': 'Volume/load',
    'tickets.ticketDetailPage.notes': 'Notes',
    'tickets.ticketDetailPage.generatedLoadsCount': 'Generated loads ({{count}})',
    'tickets.ticketDetailPage.schedule': 'Field departure {{departure}} · arrives {{arrival}}',
    'tickets.ticketDetailPage.noLoads': 'No loads generated yet. Approving the ticket generates loads using the calculated schedule.',
    'tickets.ticketDetailPage.priority.low': 'Low',
    'tickets.ticketDetailPage.priority.normal': 'Normal',
    'tickets.ticketDetailPage.priority.high': 'High',
    'tickets.ticketDetailPage.priority.urgent': 'Urgent',
    'tickets.ticketDetailPage.status.ticket.draft': 'Draft',
    'tickets.ticketDetailPage.status.ticket.submitted': 'Submitted',
    'tickets.ticketDetailPage.status.ticket.under_review': 'Under review',
    'tickets.ticketDetailPage.status.ticket.approved': 'Approved',
    'tickets.ticketDetailPage.status.ticket.in_progress': 'In progress',
    'tickets.ticketDetailPage.status.ticket.completed': 'Completed',
    'tickets.ticketDetailPage.status.ticket.cancelled': 'Cancelled',
    'tickets.ticketDetailPage.status.shipment.draft': 'Draft',
    'tickets.ticketDetailPage.status.shipment.awaiting_harvest': 'Awaiting harvest',
    'tickets.ticketDetailPage.status.shipment.loading': 'Loading',
    'tickets.ticketDetailPage.status.shipment.awaiting_invoice': 'Awaiting invoice',
    'tickets.ticketDetailPage.status.shipment.awaiting_unload': 'Awaiting unloading',
    'tickets.ticketDetailPage.status.shipment.unloading': 'Unloading',
    'tickets.ticketDetailPage.status.shipment.released': 'Released',
    'tickets.ticketDetailPage.status.shipment.cancelled': 'Cancelled',
  },
  es: {
    'tickets.ticketDetailPage.ticket': 'Ticket',
    'tickets.ticketDetailPage.ticketNumber': 'Ticket {{number}}',
    'tickets.ticketDetailPage.eyebrow': 'Operación',
    'tickets.ticketDetailPage.situation': 'Situación',
    'tickets.ticketDetailPage.priorityValue': 'Prioridad: {{priority}}',
    'tickets.ticketDetailPage.customer': 'Cliente',
    'tickets.ticketDetailPage.contract': 'Contrato',
    'tickets.ticketDetailPage.loadsQty': 'Cant. cargas',
    'tickets.ticketDetailPage.desiredDate': 'Fecha deseada',
    'tickets.ticketDetailPage.generatedLoads': 'Cargas generadas',
    'tickets.ticketDetailPage.product': 'Producto',
    'tickets.ticketDetailPage.origin': 'Origen',
    'tickets.ticketDetailPage.destination': 'Destino',
    'tickets.ticketDetailPage.priority': 'Prioridad',
    'tickets.ticketDetailPage.start': 'Inicio',
    'tickets.ticketDetailPage.intervalMin': 'Intervalo (min)',
    'tickets.ticketDetailPage.transitMin': 'Trayecto (min)',
    'tickets.ticketDetailPage.volumePerLoad': 'Volumen/carga',
    'tickets.ticketDetailPage.notes': 'Observaciones',
    'tickets.ticketDetailPage.generatedLoadsCount': 'Cargas generadas ({{count}})',
    'tickets.ticketDetailPage.schedule': 'Salida del campo {{departure}} · llega {{arrival}}',
    'tickets.ticketDetailPage.noLoads': 'Aún no se generaron cargas. Aprobar el ticket genera las cargas con la programación calculada.',
    'tickets.ticketDetailPage.priority.low': 'Baja',
    'tickets.ticketDetailPage.priority.normal': 'Normal',
    'tickets.ticketDetailPage.priority.high': 'Alta',
    'tickets.ticketDetailPage.priority.urgent': 'Urgente',
    'tickets.ticketDetailPage.status.ticket.draft': 'Borrador',
    'tickets.ticketDetailPage.status.ticket.submitted': 'Enviada',
    'tickets.ticketDetailPage.status.ticket.under_review': 'En análisis',
    'tickets.ticketDetailPage.status.ticket.approved': 'Aprobada',
    'tickets.ticketDetailPage.status.ticket.in_progress': 'En ejecución',
    'tickets.ticketDetailPage.status.ticket.completed': 'Completada',
    'tickets.ticketDetailPage.status.ticket.cancelled': 'Cancelada',
    'tickets.ticketDetailPage.status.shipment.draft': 'Borrador',
    'tickets.ticketDetailPage.status.shipment.awaiting_harvest': 'Esperando cosecha',
    'tickets.ticketDetailPage.status.shipment.loading': 'Cargando',
    'tickets.ticketDetailPage.status.shipment.awaiting_invoice': 'Esperando factura',
    'tickets.ticketDetailPage.status.shipment.awaiting_unload': 'Esperando descarga',
    'tickets.ticketDetailPage.status.shipment.unloading': 'En descarga',
    'tickets.ticketDetailPage.status.shipment.released': 'Liberada',
    'tickets.ticketDetailPage.status.shipment.cancelled': 'Cancelada',
  },
}
